import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Modalform({ showModal, handleClose }) {
  const navigate = useNavigate();

  // Captcha
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  // Optional: submit loading
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (showModal) {
      const random1 = Math.floor(Math.random() * 11) + 50; // 50-60
      const random2 = Math.floor(Math.random() * 10) + 1;  // 1-10
      setNum1(random1);
      setNum2(random2);
      setCaptchaInput("");
      setCaptchaError("");
      setSubmitting(false);
    }
  }, [showModal]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Captcha validate
    if (parseInt(captchaInput, 10) !== num1 + num2) {
      setCaptchaError("Captcha answer is incorrect. Please try again.");
      return;
    }

    const url =
      "https://script.google.com/macros/s/AKfycbxYymQLtqE8A39N-1ypTCgIHF7cYEqsi8axMGpjNrJy_Wn0fzpZ6xdxB1ux-Wgj9PTP/exec";

    const fullName = e.target.fullName.value.trim();
    const phone = e.target.phone.value.trim();
    const email = e.target.email.value.trim();
    const message = e.target.message.value.trim();
    const pageUrl = window.location.href;

    const formData = new URLSearchParams({
      Name: fullName,
      Phone: phone,
      Email: email,
      Massage: message,   // sheet column is "Massage"
      PageUrl: pageUrl,
    });

    try {
      setSubmitting(true);

      await fetch(url, {
        method: "POST",
        mode: "no-cors", // CORS safe for Apps Script
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      handleClose();
      navigate("/Thankyou");
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <form
        style={{ background: "rgb(198 87 160 / 65%)", color: "#000" }}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title>Get In Touch...</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">Enter Your Full Name</label>
              <input
                name="fullName"
                className="form-control"
                placeholder="Full Name"
                required
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Phone Number</label>
              <input
                name="phone"
                className="form-control"
                placeholder="e.g. 9876543210"
                inputMode="numeric"
                pattern="[0-9]{6,15}"
                title="Enter digits only (6-15)"
                required
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Email</label>
              <input
                name="email"
                type="email"
                className="form-control"
                placeholder="you@example.com"
                required
              />
            </div>
          </div>

          <div className="mt-2">
            <label className="form-label">Massage*</label>
            <textarea
              name="message"
              className="form-control"
              rows="4"
              placeholder="Describe your medical problem"
              required
            ></textarea>
          </div>

          <div className="mt-3">
            <label className="form-label">
              {num1} + {num2} = ?
            </label>
            <input
              type="text"
              name="captcha"
              className="form-control"
              placeholder="Enter captcha answer"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              required
            />
            {captchaError && (
              <div style={{ color: "red", marginTop: "5px" }}>{captchaError}</div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={submitting}>
            Close
          </Button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
    
  );
  
}

export default Modalform;
